module.exports = __webpack_public_path__ + "img/1.41d35018.webp";